import { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField
} from '@mui/material';
import {
  Close as CloseIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';

/**
 * Form silme onay dialogu
 */
const DeleteFormDialog = ({
  open,
  onClose,
  onConfirm,
  response,
  loading = false
}) => {
  const [explanation, setExplanation] = useState('');
  const [explanationError, setExplanationError] = useState('');

  const handleExplanationChange = (e) => {
    setExplanation(e.target.value);
    if (e.target.value.length >= 10) {
      setExplanationError('');
    }
  };

  const handleConfirm = () => {
    if (explanation.length < 10) {
      setExplanationError('En az 10 karakter açıklama gereklidir');
      return;
    }
    onConfirm(explanation);
  };

  const handleClose = () => {
    setExplanation('');
    setExplanationError('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        borderBottom: '1px solid #eee'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DeleteIcon color="error" />
          Form Silme Onayı
        </Box>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Typography>
            Bu formu silmek istediğinizden emin misiniz?
          </Typography>
          {response && (
            <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
              <Typography variant="subtitle2">Form Detayları:</Typography>
              <Typography>Başlık: {response.title || 'İsimsiz Form'}</Typography>
              <Typography>Form ID: {response.formId}</Typography>
              <Typography>
                Oluşturma Tarihi: {new Date(response.createDate).toLocaleString('tr-TR')}
              </Typography>
            </Box>
          )}
          
          <Box sx={{ mt: 3 }}>
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Silme Açıklaması"
              placeholder="Silme işlemi için en az 10 karakterlik açıklama giriniz"
              value={explanation}
              onChange={handleExplanationChange}
              error={!!explanationError}
              helperText={explanationError || `${explanation.length}/10 karakter`}
              required
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ borderTop: '1px solid #eee', p: 2 }}>
        <Button 
          onClick={handleClose} 
          variant="outlined"
          startIcon={<CloseIcon />}
        >
          İptal
        </Button>
        <Button 
          onClick={handleConfirm}
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          disabled={loading || !explanation || explanation.length < 10}
        >
          {loading ? 'Siliniyor...' : 'Sil'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteFormDialog;
